var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-dialog",
    {
      attrs: {
        width: "600"
      },
      model: {
        value: _vm.dialog,
        callback: function callback($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "gg-toolbar",
            {
              on: {
                close: _vm.close
              }
            },
            [_vm._v(" Delete zone record ")]
          ),
          _c("v-card-text", [
            _c(
              "p",
              {
                staticClass: "mb-1"
              },
              [_vm._v("Are you certain that you want to delete this record?")]
            )
          ]),
          _c(
            "v-card-actions",
            {
              staticClass: "justify-end"
            },
            [
              _c(
                "gg-btn",
                {
                  attrs: {
                    secondary: ""
                  },
                  on: {
                    click: _vm.close
                  }
                },
                [_vm._v(" Cancel ")]
              ),
              _c(
                "gg-btn",
                {
                  attrs: {
                    loading: _vm.loading
                  },
                  on: {
                    click: _vm.deleteZoneRecord
                  }
                },
                [_vm._v(" Delete ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }